// Export the generated Axios client and schemas
export * from './client';

// Export React Query hooks without re-exporting the duplicate generated schemas.
export * from './react/health';
export * from './react/default';
export * from './react/countries';
export * from './react/positions';
export * from './react/occupations';
export * from './react/webhooks';
export * from './react/accounts';
export * from './react/transfers';
export * from './react/transactions';
export * from './react/card-accounts';
export * from './react/cards';
export * from './react/card-transaction-simulator';
export * from './react/digital-custody';
export * from './react/payouts';
export * from './react/conversions';
export * from './react/fees';
export * from './react/bank-info';
export * from './react/name-check';
export * from './react/xmetadata';
export * from './react/reporting';
export * from './react/ui-accounts';

// Re-export React type for compatibility
import type * as React from 'react';
export type { React };
